import { render, staticRenderFns } from "./MarketplacesCategoryManager.vue?vue&type=template&id=3370dbd2"
import script from "./MarketplacesCategoryManager.vue?vue&type=script&lang=js"
export * from "./MarketplacesCategoryManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports